import { CONSTANTS } from './constants'

export const isAgencyCountable = (agency, type, associatedAgencies, selectedItems) => {
  switch (type) {
    case CONSTANTS.AGENCY_TYPES.ASSOCIATED:
      return associatedAgencies.includes(agency.id) || selectedItems.includes(agency.id)
    case CONSTANTS.AGENCY_TYPES.AVAILABLE:
      return !associatedAgencies.includes(agency.id)
    default:
      return true
  }
}

export const calculateAgencyCount = (sectors, type, associatedAgencies, selectedItems) => {
  return sectors.reduce((total, sector) => {
    const countableAgencies = sector.agencies.filter((agency) => isAgencyCountable(agency, type, associatedAgencies, selectedItems))
    return total + countableAgencies.length
  }, 0)
}

export const checkIfDisabled = (type, sectors, associatedAgencies) => {
  return type !== CONSTANTS.AGENCY_TYPES.AVAILABLE
    ? false
    : sectors.every((sector) => sector.agencies.every((agency) => associatedAgencies.includes(agency.id)))
}

export const getSelectedAgencyIds = (filteredSectors, type, associatedAgencies, isAllSelected, selectedItems) => {
  const agencyIds =
    type === CONSTANTS.AGENCY_TYPES.ASSOCIATED
      ? filteredSectors.map((sector) => sector.agencies.filter((agency) => associatedAgencies.includes(agency.id)).map((agency) => agency.id)).flat()
      : filteredSectors.map((sector) => sector.agencies.map((agency) => agency.id)).flat()

  return isAllSelected ? selectedItems.filter((id) => !agencyIds.includes(id)) : [...selectedItems, ...agencyIds]
}

export const getFilteredSectors = (sectors, type, associatedAgencies, selectedItems) => {
  return sectors.filter((sector) =>
    type === CONSTANTS.AGENCY_TYPES.ASSOCIATED
      ? sector.agencies.some((agency) => associatedAgencies.includes(agency.id) || selectedItems.includes(agency.id))
      : sector.agencies.length > 0,
  )
}

export const areAllAgenciesSelected = (sectors, selectedItems) => {
  return sectors.every((sector) => sector.agencies.every((agency) => selectedItems.includes(agency.id)))
}

export const sortByLabel = (first, second) => {
  if (first.label.toLowerCase() > second.label.toLowerCase()) {
    return 1
  }
  if (first.label.toLowerCase() < second.label.toLowerCase()) {
    return -1
  }
  return 0
}
